var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoLine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2254,
    height: 42,
    viewBox: "0 0 2254 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.22414 14.6964V19.9184H4.06614V20.8882H1.22414V28.3482H-0.12207V13.7266H4.29051V14.6964H1.22414Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.15234 28.3482V13.7266H10.4986V28.3482H9.15234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2019 14.6964V28.3482H16.8557V14.6964H15.2852V13.7266H19.8473V14.6964H18.2019Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2514 13.7266C28.6724 13.7266 29.2707 14.025 29.2707 15.3678V19.0978C29.2707 19.8438 28.9716 20.4406 28.1489 20.5898C29.1212 20.739 29.3455 21.4104 29.3455 22.1564V28.3482H28.0741V22.0818C28.0741 21.3358 27.8497 21.112 27.3262 21.112H25.98V28.3482H24.6338V13.7266H27.2514ZM25.98 20.1422H27.2514C27.7749 20.1422 27.9993 19.8438 27.9993 19.1724V15.6662C27.9993 14.9202 27.7749 14.6964 27.1766 14.6964H25.98V20.1422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4188 28.2735L54.3247 17.2327V28.2735H52.9785V13.6519H54.5491L56.6432 24.6927V13.6519H57.9894V28.2735H56.4188V28.2735Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8489 27.5171L31.417 41.8403H32.7632L38.9707 27.9647C38.5968 27.8901 38.2228 27.7409 37.8489 27.5171Z",
    fill: "#E40031"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3869 13.2041C37.1239 13.2041 33.6836 16.6357 33.6836 20.8879C33.6836 25.1402 37.1239 28.5718 41.3869 28.5718C45.6499 28.5718 49.0902 25.1402 49.0902 20.8879C49.0902 16.6357 45.6499 13.2041 41.3869 13.2041ZM41.3869 25.1402C39.0684 25.1402 37.1239 23.2752 37.1239 20.8879C37.1239 18.5753 38.9936 16.6357 41.3869 16.6357C43.7054 16.6357 45.6499 18.5007 45.6499 20.8879C45.6499 23.2006 43.7802 25.1402 41.3869 25.1402Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4644 0L39.293 24.5435C39.6669 24.7673 40.0409 24.9165 40.4148 24.9911L50.8106 0H49.4644Z",
    fill: "#E40031"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.224 14.6964V19.9184H126.066V20.8882H123.224V28.3482H121.878V13.7266H126.291V14.6964H123.224Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.152 28.3482V13.7266H132.499V28.3482H131.152Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.202 14.6964V28.3482H138.856V14.6964H137.285V13.7266H141.847V14.6964H140.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.251 13.7266C150.672 13.7266 151.271 14.025 151.271 15.3678V19.0978C151.271 19.8438 150.972 20.4406 150.149 20.5898C151.121 20.739 151.346 21.4104 151.346 22.1564V28.3482H150.074V22.0818C150.074 21.3358 149.85 21.112 149.326 21.112H147.98V28.3482H146.634V13.7266H149.251ZM147.98 20.1422H149.251C149.775 20.1422 149.999 19.8438 149.999 19.1724V15.6662C149.999 14.9202 149.775 14.6964 149.177 14.6964H147.98V20.1422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.419 28.2735L176.325 17.2327V28.2735H174.979V13.6519H176.549L178.643 24.6927V13.6519H179.989V28.2735H178.419V28.2735Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.849 27.5171L153.417 41.8403H154.763L160.971 27.9647C160.597 27.8901 160.223 27.7409 159.849 27.5171Z",
    fill: "#E40031"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.387 13.2041C159.124 13.2041 155.684 16.6357 155.684 20.8879C155.684 25.1402 159.124 28.5718 163.387 28.5718C167.65 28.5718 171.09 25.1402 171.09 20.8879C171.09 16.6357 167.65 13.2041 163.387 13.2041ZM163.387 25.1402C161.068 25.1402 159.124 23.2752 159.124 20.8879C159.124 18.5753 160.994 16.6357 163.387 16.6357C165.705 16.6357 167.65 18.5007 167.65 20.8879C167.65 23.2006 165.78 25.1402 163.387 25.1402Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.464 0L161.293 24.5435C161.667 24.7673 162.041 24.9165 162.415 24.9911L172.811 0H171.464Z",
    fill: "#E40031"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245.224 14.6964V19.9184H248.066V20.8882H245.224V28.3482H243.878V13.7266H248.291V14.6964H245.224Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.152 28.3482V13.7266H254.499V28.3482H253.152Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.202 14.6964V28.3482H260.856V14.6964H259.285V13.7266H263.847V14.6964H262.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.251 13.7266C272.672 13.7266 273.271 14.025 273.271 15.3678V19.0978C273.271 19.8438 272.972 20.4406 272.149 20.5898C273.121 20.739 273.346 21.4104 273.346 22.1564V28.3482H272.074V22.0818C272.074 21.3358 271.85 21.112 271.326 21.112H269.98V28.3482H268.634V13.7266H271.251ZM269.98 20.1422H271.251C271.775 20.1422 271.999 19.8438 271.999 19.1724V15.6662C271.999 14.9202 271.775 14.6964 271.177 14.6964H269.98V20.1422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.419 28.2735L298.325 17.2327V28.2735H296.979V13.6519H298.549L300.643 24.6927V13.6519H301.989V28.2735H300.419V28.2735Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.849 27.5171L275.417 41.8403H276.763L282.971 27.9647C282.597 27.8901 282.223 27.7409 281.849 27.5171Z",
    fill: "#E40031"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.387 13.2041C281.124 13.2041 277.684 16.6357 277.684 20.8879C277.684 25.1402 281.124 28.5718 285.387 28.5718C289.65 28.5718 293.09 25.1402 293.09 20.8879C293.09 16.6357 289.65 13.2041 285.387 13.2041ZM285.387 25.1402C283.068 25.1402 281.124 23.2752 281.124 20.8879C281.124 18.5753 282.994 16.6357 285.387 16.6357C287.705 16.6357 289.65 18.5007 289.65 20.8879C289.65 23.2006 287.78 25.1402 285.387 25.1402Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.464 0L283.293 24.5435C283.667 24.7673 284.041 24.9165 284.415 24.9911L294.811 0H293.464Z",
    fill: "#E40031"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M367.224 14.6964V19.9184H370.066V20.8882H367.224V28.3482H365.878V13.7266H370.291V14.6964H367.224Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.152 28.3482V13.7266H376.499V28.3482H375.152Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.202 14.6964V28.3482H382.856V14.6964H381.285V13.7266H385.847V14.6964H384.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.251 13.7266C394.672 13.7266 395.271 14.025 395.271 15.3678V19.0978C395.271 19.8438 394.972 20.4406 394.149 20.5898C395.121 20.739 395.346 21.4104 395.346 22.1564V28.3482H394.074V22.0818C394.074 21.3358 393.85 21.112 393.326 21.112H391.98V28.3482H390.634V13.7266H393.251ZM391.98 20.1422H393.251C393.775 20.1422 393.999 19.8438 393.999 19.1724V15.6662C393.999 14.9202 393.775 14.6964 393.177 14.6964H391.98V20.1422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.419 28.2735L420.325 17.2327V28.2735H418.979V13.6519H420.549L422.643 24.6927V13.6519H423.989V28.2735H422.419V28.2735Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.849 27.5171L397.417 41.8403H398.763L404.971 27.9647C404.597 27.8901 404.223 27.7409 403.849 27.5171Z",
    fill: "#E40031"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.387 13.2041C403.124 13.2041 399.684 16.6357 399.684 20.8879C399.684 25.1402 403.124 28.5718 407.387 28.5718C411.65 28.5718 415.09 25.1402 415.09 20.8879C415.09 16.6357 411.65 13.2041 407.387 13.2041ZM407.387 25.1402C405.068 25.1402 403.124 23.2752 403.124 20.8879C403.124 18.5753 404.994 16.6357 407.387 16.6357C409.705 16.6357 411.65 18.5007 411.65 20.8879C411.65 23.2006 409.78 25.1402 407.387 25.1402Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.464 0L405.293 24.5435C405.667 24.7673 406.041 24.9165 406.415 24.9911L416.811 0H415.464Z",
    fill: "#E40031"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M489.224 14.6964V19.9184H492.066V20.8882H489.224V28.3482H487.878V13.7266H492.291V14.6964H489.224Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.152 28.3482V13.7266H498.499V28.3482H497.152Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.202 14.6964V28.3482H504.856V14.6964H503.285V13.7266H507.847V14.6964H506.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.251 13.7266C516.672 13.7266 517.271 14.025 517.271 15.3678V19.0978C517.271 19.8438 516.972 20.4406 516.149 20.5898C517.121 20.739 517.346 21.4104 517.346 22.1564V28.3482H516.074V22.0818C516.074 21.3358 515.85 21.112 515.326 21.112H513.98V28.3482H512.634V13.7266H515.251ZM513.98 20.1422H515.251C515.775 20.1422 515.999 19.8438 515.999 19.1724V15.6662C515.999 14.9202 515.775 14.6964 515.177 14.6964H513.98V20.1422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.419 28.2735L542.325 17.2327V28.2735H540.979V13.6519H542.549L544.643 24.6927V13.6519H545.989V28.2735H544.419V28.2735Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.849 27.5171L519.417 41.8403H520.763L526.971 27.9647C526.597 27.8901 526.223 27.7409 525.849 27.5171Z",
    fill: "#E40031"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.387 13.2041C525.124 13.2041 521.684 16.6357 521.684 20.8879C521.684 25.1402 525.124 28.5718 529.387 28.5718C533.65 28.5718 537.09 25.1402 537.09 20.8879C537.09 16.6357 533.65 13.2041 529.387 13.2041ZM529.387 25.1402C527.068 25.1402 525.124 23.2752 525.124 20.8879C525.124 18.5753 526.994 16.6357 529.387 16.6357C531.705 16.6357 533.65 18.5007 533.65 20.8879C533.65 23.2006 531.78 25.1402 529.387 25.1402Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.464 0L527.293 24.5435C527.667 24.7673 528.041 24.9165 528.415 24.9911L538.811 0H537.464Z",
    fill: "#E40031"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M611.224 14.6964V19.9184H614.066V20.8882H611.224V28.3482H609.878V13.7266H614.291V14.6964H611.224Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.152 28.3482V13.7266H620.499V28.3482H619.152Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.202 14.6964V28.3482H626.856V14.6964H625.285V13.7266H629.847V14.6964H628.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.251 13.7266C638.672 13.7266 639.271 14.025 639.271 15.3678V19.0978C639.271 19.8438 638.972 20.4406 638.149 20.5898C639.121 20.739 639.346 21.4104 639.346 22.1564V28.3482H638.074V22.0818C638.074 21.3358 637.85 21.112 637.326 21.112H635.98V28.3482H634.634V13.7266H637.251ZM635.98 20.1422H637.251C637.775 20.1422 637.999 19.8438 637.999 19.1724V15.6662C637.999 14.9202 637.775 14.6964 637.177 14.6964H635.98V20.1422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.419 28.2735L664.325 17.2327V28.2735H662.979V13.6519H664.549L666.643 24.6927V13.6519H667.989V28.2735H666.419V28.2735Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.849 27.5171L641.417 41.8403H642.763L648.971 27.9647C648.597 27.8901 648.223 27.7409 647.849 27.5171Z",
    fill: "#E40031"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.387 13.2041C647.124 13.2041 643.684 16.6357 643.684 20.8879C643.684 25.1402 647.124 28.5718 651.387 28.5718C655.65 28.5718 659.09 25.1402 659.09 20.8879C659.09 16.6357 655.65 13.2041 651.387 13.2041ZM651.387 25.1402C649.068 25.1402 647.124 23.2752 647.124 20.8879C647.124 18.5753 648.994 16.6357 651.387 16.6357C653.705 16.6357 655.65 18.5007 655.65 20.8879C655.65 23.2006 653.78 25.1402 651.387 25.1402Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.464 0L649.293 24.5435C649.667 24.7673 650.041 24.9165 650.415 24.9911L660.811 0H659.464Z",
    fill: "#E40031"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M733.224 14.6964V19.9184H736.066V20.8882H733.224V28.3482H731.878V13.7266H736.291V14.6964H733.224Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.152 28.3482V13.7266H742.499V28.3482H741.152Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.202 14.6964V28.3482H748.856V14.6964H747.285V13.7266H751.847V14.6964H750.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.251 13.7266C760.672 13.7266 761.271 14.025 761.271 15.3678V19.0978C761.271 19.8438 760.972 20.4406 760.149 20.5898C761.121 20.739 761.346 21.4104 761.346 22.1564V28.3482H760.074V22.0818C760.074 21.3358 759.85 21.112 759.326 21.112H757.98V28.3482H756.634V13.7266H759.251ZM757.98 20.1422H759.251C759.775 20.1422 759.999 19.8438 759.999 19.1724V15.6662C759.999 14.9202 759.775 14.6964 759.177 14.6964H757.98V20.1422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M788.419 28.2735L786.325 17.2327V28.2735H784.979V13.6519H786.549L788.643 24.6927V13.6519H789.989V28.2735H788.419V28.2735Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.849 27.5171L763.417 41.8403H764.763L770.971 27.9647C770.597 27.8901 770.223 27.7409 769.849 27.5171Z",
    fill: "#E40031"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M773.387 13.2041C769.124 13.2041 765.684 16.6357 765.684 20.8879C765.684 25.1402 769.124 28.5718 773.387 28.5718C777.65 28.5718 781.09 25.1402 781.09 20.8879C781.09 16.6357 777.65 13.2041 773.387 13.2041ZM773.387 25.1402C771.068 25.1402 769.124 23.2752 769.124 20.8879C769.124 18.5753 770.994 16.6357 773.387 16.6357C775.705 16.6357 777.65 18.5007 777.65 20.8879C777.65 23.2006 775.78 25.1402 773.387 25.1402Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.464 0L771.293 24.5435C771.667 24.7673 772.041 24.9165 772.415 24.9911L782.811 0H781.464Z",
    fill: "#E40031"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M855.224 14.6964V19.9184H858.066V20.8882H855.224V28.3482H853.878V13.7266H858.291V14.6964H855.224Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863.152 28.3482V13.7266H864.499V28.3482H863.152Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.202 14.6964V28.3482H870.856V14.6964H869.285V13.7266H873.847V14.6964H872.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M881.251 13.7266C882.672 13.7266 883.271 14.025 883.271 15.3678V19.0978C883.271 19.8438 882.972 20.4406 882.149 20.5898C883.121 20.739 883.346 21.4104 883.346 22.1564V28.3482H882.074V22.0818C882.074 21.3358 881.85 21.112 881.326 21.112H879.98V28.3482H878.634V13.7266H881.251ZM879.98 20.1422H881.251C881.775 20.1422 881.999 19.8438 881.999 19.1724V15.6662C881.999 14.9202 881.775 14.6964 881.177 14.6964H879.98V20.1422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M910.419 28.2735L908.325 17.2327V28.2735H906.979V13.6519H908.549L910.643 24.6927V13.6519H911.989V28.2735H910.419V28.2735Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.849 27.5171L885.417 41.8403H886.763L892.971 27.9647C892.597 27.8901 892.223 27.7409 891.849 27.5171Z",
    fill: "#E40031"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.387 13.2041C891.124 13.2041 887.684 16.6357 887.684 20.8879C887.684 25.1402 891.124 28.5718 895.387 28.5718C899.65 28.5718 903.09 25.1402 903.09 20.8879C903.09 16.6357 899.65 13.2041 895.387 13.2041ZM895.387 25.1402C893.068 25.1402 891.124 23.2752 891.124 20.8879C891.124 18.5753 892.994 16.6357 895.387 16.6357C897.705 16.6357 899.65 18.5007 899.65 20.8879C899.65 23.2006 897.78 25.1402 895.387 25.1402Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M903.464 0L893.293 24.5435C893.667 24.7673 894.041 24.9165 894.415 24.9911L904.811 0H903.464Z",
    fill: "#E40031"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M977.224 14.6964V19.9184H980.066V20.8882H977.224V28.3482H975.878V13.7266H980.291V14.6964H977.224Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.152 28.3482V13.7266H986.499V28.3482H985.152Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M994.202 14.6964V28.3482H992.856V14.6964H991.285V13.7266H995.847V14.6964H994.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.25 13.7266C1004.67 13.7266 1005.27 14.025 1005.27 15.3678V19.0978C1005.27 19.8438 1004.97 20.4406 1004.15 20.5898C1005.12 20.739 1005.35 21.4104 1005.35 22.1564V28.3482H1004.07V22.0818C1004.07 21.3358 1003.85 21.112 1003.33 21.112H1001.98V28.3482H1000.63V13.7266H1003.25ZM1001.98 20.1422H1003.25C1003.77 20.1422 1004 19.8438 1004 19.1724V15.6662C1004 14.9202 1003.77 14.6964 1003.18 14.6964H1001.98V20.1422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.42 28.2735L1030.32 17.2327V28.2735H1028.98V13.6519H1030.55L1032.64 24.6927V13.6519H1033.99V28.2735H1032.42V28.2735Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.85 27.5171L1007.42 41.8403H1008.76L1014.97 27.9647C1014.6 27.8901 1014.22 27.7409 1013.85 27.5171Z",
    fill: "#E40031"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017.39 13.2041C1013.12 13.2041 1009.68 16.6357 1009.68 20.8879C1009.68 25.1402 1013.12 28.5718 1017.39 28.5718C1021.65 28.5718 1025.09 25.1402 1025.09 20.8879C1025.09 16.6357 1021.65 13.2041 1017.39 13.2041ZM1017.39 25.1402C1015.07 25.1402 1013.12 23.2752 1013.12 20.8879C1013.12 18.5753 1014.99 16.6357 1017.39 16.6357C1019.71 16.6357 1021.65 18.5007 1021.65 20.8879C1021.65 23.2006 1019.78 25.1402 1017.39 25.1402Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1025.46 0L1015.29 24.5435C1015.67 24.7673 1016.04 24.9165 1016.41 24.9911L1026.81 0H1025.46Z",
    fill: "#E40031"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1099.22 14.6964V19.9184H1102.07V20.8882H1099.22V28.3482H1097.88V13.7266H1102.29V14.6964H1099.22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1107.15 28.3482V13.7266H1108.5V28.3482H1107.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1116.2 14.6964V28.3482H1114.86V14.6964H1113.29V13.7266H1117.85V14.6964H1116.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1125.25 13.7266C1126.67 13.7266 1127.27 14.025 1127.27 15.3678V19.0978C1127.27 19.8438 1126.97 20.4406 1126.15 20.5898C1127.12 20.739 1127.35 21.4104 1127.35 22.1564V28.3482H1126.07V22.0818C1126.07 21.3358 1125.85 21.112 1125.33 21.112H1123.98V28.3482H1122.63V13.7266H1125.25ZM1123.98 20.1422H1125.25C1125.77 20.1422 1126 19.8438 1126 19.1724V15.6662C1126 14.9202 1125.77 14.6964 1125.18 14.6964H1123.98V20.1422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1154.42 28.2735L1152.32 17.2327V28.2735H1150.98V13.6519H1152.55L1154.64 24.6927V13.6519H1155.99V28.2735H1154.42V28.2735Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1135.85 27.5171L1129.42 41.8403H1130.76L1136.97 27.9647C1136.6 27.8901 1136.22 27.7409 1135.85 27.5171Z",
    fill: "#E40031"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1139.39 13.2041C1135.12 13.2041 1131.68 16.6357 1131.68 20.8879C1131.68 25.1402 1135.12 28.5718 1139.39 28.5718C1143.65 28.5718 1147.09 25.1402 1147.09 20.8879C1147.09 16.6357 1143.65 13.2041 1139.39 13.2041ZM1139.39 25.1402C1137.07 25.1402 1135.12 23.2752 1135.12 20.8879C1135.12 18.5753 1136.99 16.6357 1139.39 16.6357C1141.71 16.6357 1143.65 18.5007 1143.65 20.8879C1143.65 23.2006 1141.78 25.1402 1139.39 25.1402Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.46 0L1137.29 24.5435C1137.67 24.7673 1138.04 24.9165 1138.41 24.9911L1148.81 0H1147.46Z",
    fill: "#E40031"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1221.22 14.6964V19.9184H1224.07V20.8882H1221.22V28.3482H1219.88V13.7266H1224.29V14.6964H1221.22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1229.15 28.3482V13.7266H1230.5V28.3482H1229.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1238.2 14.6964V28.3482H1236.86V14.6964H1235.29V13.7266H1239.85V14.6964H1238.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1247.25 13.7266C1248.67 13.7266 1249.27 14.025 1249.27 15.3678V19.0978C1249.27 19.8438 1248.97 20.4406 1248.15 20.5898C1249.12 20.739 1249.35 21.4104 1249.35 22.1564V28.3482H1248.07V22.0818C1248.07 21.3358 1247.85 21.112 1247.33 21.112H1245.98V28.3482H1244.63V13.7266H1247.25ZM1245.98 20.1422H1247.25C1247.77 20.1422 1248 19.8438 1248 19.1724V15.6662C1248 14.9202 1247.77 14.6964 1247.18 14.6964H1245.98V20.1422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1276.42 28.2735L1274.32 17.2327V28.2735H1272.98V13.6519H1274.55L1276.64 24.6927V13.6519H1277.99V28.2735H1276.42V28.2735Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1257.85 27.5171L1251.42 41.8403H1252.76L1258.97 27.9647C1258.6 27.8901 1258.22 27.7409 1257.85 27.5171Z",
    fill: "#E40031"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1261.39 13.2041C1257.12 13.2041 1253.68 16.6357 1253.68 20.8879C1253.68 25.1402 1257.12 28.5718 1261.39 28.5718C1265.65 28.5718 1269.09 25.1402 1269.09 20.8879C1269.09 16.6357 1265.65 13.2041 1261.39 13.2041ZM1261.39 25.1402C1259.07 25.1402 1257.12 23.2752 1257.12 20.8879C1257.12 18.5753 1258.99 16.6357 1261.39 16.6357C1263.71 16.6357 1265.65 18.5007 1265.65 20.8879C1265.65 23.2006 1263.78 25.1402 1261.39 25.1402Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1269.46 0L1259.29 24.5435C1259.67 24.7673 1260.04 24.9165 1260.41 24.9911L1270.81 0H1269.46Z",
    fill: "#E40031"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1343.22 14.6964V19.9184H1346.07V20.8882H1343.22V28.3482H1341.88V13.7266H1346.29V14.6964H1343.22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1351.15 28.3482V13.7266H1352.5V28.3482H1351.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1360.2 14.6964V28.3482H1358.86V14.6964H1357.29V13.7266H1361.85V14.6964H1360.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1369.25 13.7266C1370.67 13.7266 1371.27 14.025 1371.27 15.3678V19.0978C1371.27 19.8438 1370.97 20.4406 1370.15 20.5898C1371.12 20.739 1371.35 21.4104 1371.35 22.1564V28.3482H1370.07V22.0818C1370.07 21.3358 1369.85 21.112 1369.33 21.112H1367.98V28.3482H1366.63V13.7266H1369.25ZM1367.98 20.1422H1369.25C1369.77 20.1422 1370 19.8438 1370 19.1724V15.6662C1370 14.9202 1369.77 14.6964 1369.18 14.6964H1367.98V20.1422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1398.42 28.2735L1396.33 17.2327V28.2735H1394.98V13.6519H1396.55L1398.64 24.6927V13.6519H1399.99V28.2735H1398.42V28.2735Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1379.85 27.5171L1373.42 41.8403H1374.76L1380.97 27.9647C1380.6 27.8901 1380.22 27.7409 1379.85 27.5171Z",
    fill: "#E40031"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1383.39 13.2041C1379.12 13.2041 1375.68 16.6357 1375.68 20.8879C1375.68 25.1402 1379.12 28.5718 1383.39 28.5718C1387.65 28.5718 1391.09 25.1402 1391.09 20.8879C1391.09 16.6357 1387.65 13.2041 1383.39 13.2041ZM1383.39 25.1402C1381.07 25.1402 1379.12 23.2752 1379.12 20.8879C1379.12 18.5753 1380.99 16.6357 1383.39 16.6357C1385.7 16.6357 1387.65 18.5007 1387.65 20.8879C1387.65 23.2006 1385.78 25.1402 1383.39 25.1402Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1391.46 0L1381.29 24.5435C1381.67 24.7673 1382.04 24.9165 1382.41 24.9911L1392.81 0H1391.46Z",
    fill: "#E40031"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1465.22 14.6964V19.9184H1468.07V20.8882H1465.22V28.3482H1463.88V13.7266H1468.29V14.6964H1465.22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1473.15 28.3482V13.7266H1474.5V28.3482H1473.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1482.2 14.6964V28.3482H1480.86V14.6964H1479.29V13.7266H1483.85V14.6964H1482.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1491.25 13.7266C1492.67 13.7266 1493.27 14.025 1493.27 15.3678V19.0978C1493.27 19.8438 1492.97 20.4406 1492.15 20.5898C1493.12 20.739 1493.35 21.4104 1493.35 22.1564V28.3482H1492.07V22.0818C1492.07 21.3358 1491.85 21.112 1491.33 21.112H1489.98V28.3482H1488.63V13.7266H1491.25ZM1489.98 20.1422H1491.25C1491.77 20.1422 1492 19.8438 1492 19.1724V15.6662C1492 14.9202 1491.77 14.6964 1491.18 14.6964H1489.98V20.1422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1520.42 28.2735L1518.33 17.2327V28.2735H1516.98V13.6519H1518.55L1520.64 24.6927V13.6519H1521.99V28.2735H1520.42V28.2735Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1501.85 27.5171L1495.42 41.8403H1496.76L1502.97 27.9647C1502.6 27.8901 1502.22 27.7409 1501.85 27.5171Z",
    fill: "#E40031"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1505.39 13.2041C1501.12 13.2041 1497.68 16.6357 1497.68 20.8879C1497.68 25.1402 1501.12 28.5718 1505.39 28.5718C1509.65 28.5718 1513.09 25.1402 1513.09 20.8879C1513.09 16.6357 1509.65 13.2041 1505.39 13.2041ZM1505.39 25.1402C1503.07 25.1402 1501.12 23.2752 1501.12 20.8879C1501.12 18.5753 1502.99 16.6357 1505.39 16.6357C1507.7 16.6357 1509.65 18.5007 1509.65 20.8879C1509.65 23.2006 1507.78 25.1402 1505.39 25.1402Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1513.46 0L1503.29 24.5435C1503.67 24.7673 1504.04 24.9165 1504.41 24.9911L1514.81 0H1513.46Z",
    fill: "#E40031"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1587.22 14.6964V19.9184H1590.07V20.8882H1587.22V28.3482H1585.88V13.7266H1590.29V14.6964H1587.22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1595.15 28.3482V13.7266H1596.5V28.3482H1595.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1604.2 14.6964V28.3482H1602.86V14.6964H1601.29V13.7266H1605.85V14.6964H1604.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1613.25 13.7266C1614.67 13.7266 1615.27 14.025 1615.27 15.3678V19.0978C1615.27 19.8438 1614.97 20.4406 1614.15 20.5898C1615.12 20.739 1615.35 21.4104 1615.35 22.1564V28.3482H1614.07V22.0818C1614.07 21.3358 1613.85 21.112 1613.33 21.112H1611.98V28.3482H1610.63V13.7266H1613.25ZM1611.98 20.1422H1613.25C1613.77 20.1422 1614 19.8438 1614 19.1724V15.6662C1614 14.9202 1613.77 14.6964 1613.18 14.6964H1611.98V20.1422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1642.42 28.2735L1640.33 17.2327V28.2735H1638.98V13.6519H1640.55L1642.64 24.6927V13.6519H1643.99V28.2735H1642.42V28.2735Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1623.85 27.5171L1617.42 41.8403H1618.76L1624.97 27.9647C1624.6 27.8901 1624.22 27.7409 1623.85 27.5171Z",
    fill: "#E40031"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1627.39 13.2041C1623.12 13.2041 1619.68 16.6357 1619.68 20.8879C1619.68 25.1402 1623.12 28.5718 1627.39 28.5718C1631.65 28.5718 1635.09 25.1402 1635.09 20.8879C1635.09 16.6357 1631.65 13.2041 1627.39 13.2041ZM1627.39 25.1402C1625.07 25.1402 1623.12 23.2752 1623.12 20.8879C1623.12 18.5753 1624.99 16.6357 1627.39 16.6357C1629.7 16.6357 1631.65 18.5007 1631.65 20.8879C1631.65 23.2006 1629.78 25.1402 1627.39 25.1402Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1635.46 0L1625.29 24.5435C1625.67 24.7673 1626.04 24.9165 1626.41 24.9911L1636.81 0H1635.46Z",
    fill: "#E40031"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1709.22 14.6964V19.9184H1712.07V20.8882H1709.22V28.3482H1707.88V13.7266H1712.29V14.6964H1709.22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1717.15 28.3482V13.7266H1718.5V28.3482H1717.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1726.2 14.6964V28.3482H1724.86V14.6964H1723.29V13.7266H1727.85V14.6964H1726.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1735.25 13.7266C1736.67 13.7266 1737.27 14.025 1737.27 15.3678V19.0978C1737.27 19.8438 1736.97 20.4406 1736.15 20.5898C1737.12 20.739 1737.35 21.4104 1737.35 22.1564V28.3482H1736.07V22.0818C1736.07 21.3358 1735.85 21.112 1735.33 21.112H1733.98V28.3482H1732.63V13.7266H1735.25ZM1733.98 20.1422H1735.25C1735.77 20.1422 1736 19.8438 1736 19.1724V15.6662C1736 14.9202 1735.77 14.6964 1735.18 14.6964H1733.98V20.1422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1764.42 28.2735L1762.33 17.2327V28.2735H1760.98V13.6519H1762.55L1764.64 24.6927V13.6519H1765.99V28.2735H1764.42V28.2735Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1745.85 27.5171L1739.42 41.8403H1740.76L1746.97 27.9647C1746.6 27.8901 1746.22 27.7409 1745.85 27.5171Z",
    fill: "#E40031"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1749.39 13.2041C1745.12 13.2041 1741.68 16.6357 1741.68 20.8879C1741.68 25.1402 1745.12 28.5718 1749.39 28.5718C1753.65 28.5718 1757.09 25.1402 1757.09 20.8879C1757.09 16.6357 1753.65 13.2041 1749.39 13.2041ZM1749.39 25.1402C1747.07 25.1402 1745.12 23.2752 1745.12 20.8879C1745.12 18.5753 1746.99 16.6357 1749.39 16.6357C1751.7 16.6357 1753.65 18.5007 1753.65 20.8879C1753.65 23.2006 1751.78 25.1402 1749.39 25.1402Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1757.46 0L1747.29 24.5435C1747.67 24.7673 1748.04 24.9165 1748.41 24.9911L1758.81 0H1757.46Z",
    fill: "#E40031"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1831.22 14.6964V19.9184H1834.07V20.8882H1831.22V28.3482H1829.88V13.7266H1834.29V14.6964H1831.22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1839.15 28.3482V13.7266H1840.5V28.3482H1839.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1848.2 14.6964V28.3482H1846.86V14.6964H1845.29V13.7266H1849.85V14.6964H1848.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1857.25 13.7266C1858.67 13.7266 1859.27 14.025 1859.27 15.3678V19.0978C1859.27 19.8438 1858.97 20.4406 1858.15 20.5898C1859.12 20.739 1859.35 21.4104 1859.35 22.1564V28.3482H1858.07V22.0818C1858.07 21.3358 1857.85 21.112 1857.33 21.112H1855.98V28.3482H1854.63V13.7266H1857.25ZM1855.98 20.1422H1857.25C1857.77 20.1422 1858 19.8438 1858 19.1724V15.6662C1858 14.9202 1857.77 14.6964 1857.18 14.6964H1855.98V20.1422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1886.42 28.2735L1884.33 17.2327V28.2735H1882.98V13.6519H1884.55L1886.64 24.6927V13.6519H1887.99V28.2735H1886.42V28.2735Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1867.85 27.5171L1861.42 41.8403H1862.76L1868.97 27.9647C1868.6 27.8901 1868.22 27.7409 1867.85 27.5171Z",
    fill: "#E40031"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1871.39 13.2041C1867.12 13.2041 1863.68 16.6357 1863.68 20.8879C1863.68 25.1402 1867.12 28.5718 1871.39 28.5718C1875.65 28.5718 1879.09 25.1402 1879.09 20.8879C1879.09 16.6357 1875.65 13.2041 1871.39 13.2041ZM1871.39 25.1402C1869.07 25.1402 1867.12 23.2752 1867.12 20.8879C1867.12 18.5753 1868.99 16.6357 1871.39 16.6357C1873.7 16.6357 1875.65 18.5007 1875.65 20.8879C1875.65 23.2006 1873.78 25.1402 1871.39 25.1402Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1879.46 0L1869.29 24.5435C1869.67 24.7673 1870.04 24.9165 1870.41 24.9911L1880.81 0H1879.46Z",
    fill: "#E40031"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1953.22 14.6964V19.9184H1956.07V20.8882H1953.22V28.3482H1951.88V13.7266H1956.29V14.6964H1953.22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1961.15 28.3482V13.7266H1962.5V28.3482H1961.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1970.2 14.6964V28.3482H1968.86V14.6964H1967.29V13.7266H1971.85V14.6964H1970.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1979.25 13.7266C1980.67 13.7266 1981.27 14.025 1981.27 15.3678V19.0978C1981.27 19.8438 1980.97 20.4406 1980.15 20.5898C1981.12 20.739 1981.35 21.4104 1981.35 22.1564V28.3482H1980.07V22.0818C1980.07 21.3358 1979.85 21.112 1979.33 21.112H1977.98V28.3482H1976.63V13.7266H1979.25ZM1977.98 20.1422H1979.25C1979.77 20.1422 1980 19.8438 1980 19.1724V15.6662C1980 14.9202 1979.77 14.6964 1979.18 14.6964H1977.98V20.1422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2008.42 28.2735L2006.33 17.2327V28.2735H2004.98V13.6519H2006.55L2008.64 24.6927V13.6519H2009.99V28.2735H2008.42V28.2735Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1989.85 27.5171L1983.42 41.8403H1984.76L1990.97 27.9647C1990.6 27.8901 1990.22 27.7409 1989.85 27.5171Z",
    fill: "#E40031"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1993.39 13.2041C1989.12 13.2041 1985.68 16.6357 1985.68 20.8879C1985.68 25.1402 1989.12 28.5718 1993.39 28.5718C1997.65 28.5718 2001.09 25.1402 2001.09 20.8879C2001.09 16.6357 1997.65 13.2041 1993.39 13.2041ZM1993.39 25.1402C1991.07 25.1402 1989.12 23.2752 1989.12 20.8879C1989.12 18.5753 1990.99 16.6357 1993.39 16.6357C1995.7 16.6357 1997.65 18.5007 1997.65 20.8879C1997.65 23.2006 1995.78 25.1402 1993.39 25.1402Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2001.46 0L1991.29 24.5435C1991.67 24.7673 1992.04 24.9165 1992.41 24.9911L2002.81 0H2001.46Z",
    fill: "#E40031"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2075.22 14.6964V19.9184H2078.07V20.8882H2075.22V28.3482H2073.88V13.7266H2078.29V14.6964H2075.22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2083.15 28.3482V13.7266H2084.5V28.3482H2083.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2092.2 14.6964V28.3482H2090.86V14.6964H2089.29V13.7266H2093.85V14.6964H2092.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2101.25 13.7266C2102.67 13.7266 2103.27 14.025 2103.27 15.3678V19.0978C2103.27 19.8438 2102.97 20.4406 2102.15 20.5898C2103.12 20.739 2103.35 21.4104 2103.35 22.1564V28.3482H2102.07V22.0818C2102.07 21.3358 2101.85 21.112 2101.33 21.112H2099.98V28.3482H2098.63V13.7266H2101.25ZM2099.98 20.1422H2101.25C2101.77 20.1422 2102 19.8438 2102 19.1724V15.6662C2102 14.9202 2101.77 14.6964 2101.18 14.6964H2099.98V20.1422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2130.42 28.2735L2128.33 17.2327V28.2735H2126.98V13.6519H2128.55L2130.64 24.6927V13.6519H2131.99V28.2735H2130.42V28.2735Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2111.85 27.5171L2105.42 41.8403H2106.76L2112.97 27.9647C2112.6 27.8901 2112.22 27.7409 2111.85 27.5171Z",
    fill: "#E40031"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2115.39 13.2041C2111.12 13.2041 2107.68 16.6357 2107.68 20.8879C2107.68 25.1402 2111.12 28.5718 2115.39 28.5718C2119.65 28.5718 2123.09 25.1402 2123.09 20.8879C2123.09 16.6357 2119.65 13.2041 2115.39 13.2041ZM2115.39 25.1402C2113.07 25.1402 2111.12 23.2752 2111.12 20.8879C2111.12 18.5753 2112.99 16.6357 2115.39 16.6357C2117.7 16.6357 2119.65 18.5007 2119.65 20.8879C2119.65 23.2006 2117.78 25.1402 2115.39 25.1402Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2123.46 0L2113.29 24.5435C2113.67 24.7673 2114.04 24.9165 2114.41 24.9911L2124.81 0H2123.46Z",
    fill: "#E40031"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2197.22 14.6964V19.9184H2200.07V20.8882H2197.22V28.3482H2195.88V13.7266H2200.29V14.6964H2197.22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2205.15 28.3482V13.7266H2206.5V28.3482H2205.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2214.2 14.6964V28.3482H2212.86V14.6964H2211.29V13.7266H2215.85V14.6964H2214.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2223.25 13.7266C2224.67 13.7266 2225.27 14.025 2225.27 15.3678V19.0978C2225.27 19.8438 2224.97 20.4406 2224.15 20.5898C2225.12 20.739 2225.35 21.4104 2225.35 22.1564V28.3482H2224.07V22.0818C2224.07 21.3358 2223.85 21.112 2223.33 21.112H2221.98V28.3482H2220.63V13.7266H2223.25ZM2221.98 20.1422H2223.25C2223.77 20.1422 2224 19.8438 2224 19.1724V15.6662C2224 14.9202 2223.77 14.6964 2223.18 14.6964H2221.98V20.1422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2252.42 28.2735L2250.33 17.2327V28.2735H2248.98V13.6519H2250.55L2252.64 24.6927V13.6519H2253.99V28.2735H2252.42V28.2735Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2233.85 27.5171L2227.42 41.8403H2228.76L2234.97 27.9647C2234.6 27.8901 2234.22 27.7409 2233.85 27.5171Z",
    fill: "#E40031"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2237.39 13.2041C2233.12 13.2041 2229.68 16.6357 2229.68 20.8879C2229.68 25.1402 2233.12 28.5718 2237.39 28.5718C2241.65 28.5718 2245.09 25.1402 2245.09 20.8879C2245.09 16.6357 2241.65 13.2041 2237.39 13.2041ZM2237.39 25.1402C2235.07 25.1402 2233.12 23.2752 2233.12 20.8879C2233.12 18.5753 2234.99 16.6357 2237.39 16.6357C2239.7 16.6357 2241.65 18.5007 2241.65 20.8879C2241.65 23.2006 2239.78 25.1402 2237.39 25.1402Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2245.46 0L2235.29 24.5435C2235.67 24.7673 2236.04 24.9165 2236.41 24.9911L2246.81 0H2245.46Z",
    fill: "#E40031"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 42,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 122,
    width: 58,
    height: 42,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 244,
    width: 58,
    height: 42,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 366,
    width: 58,
    height: 42,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 488,
    width: 58,
    height: 42,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 610,
    width: 58,
    height: 42,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 732,
    width: 58,
    height: 42,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 854,
    width: 58,
    height: 42,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 976,
    width: 58,
    height: 42,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1098,
    width: 58,
    height: 42,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1220,
    width: 58,
    height: 42,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip11"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1342,
    width: 58,
    height: 42,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip12"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1464,
    width: 58,
    height: 42,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1586,
    width: 58,
    height: 42,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip14"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1708,
    width: 58,
    height: 42,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip15"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1830,
    width: 58,
    height: 42,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip16"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1952,
    width: 58,
    height: 42,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip17"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2074,
    width: 58,
    height: 42,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip18"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2196,
    width: 58,
    height: 42,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLine);
export default __webpack_public_path__ + "static/media/logo-line.539fbbcaf8063bf3a3f77b479c2938e4.svg";
export { ForwardRef as ReactComponent };